import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import styles from './LiveTag.module.scss';

const TRANSLATION_KEY = 'tag_envivo';

const LiveTag = ({ className, ...rest }) => {
  const translations = useSelector(state => state.translations);
  const label = getTranslationEmptyOrNullKey(TRANSLATION_KEY, translations);

  return (
    <span className={classNames(styles.liveTag, className)} {...rest}>
      {label}
    </span>
  );
};

export default LiveTag;
